import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { end, start } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { ListFilterRequest, TuttiBatchUploadResponse } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_TUTTI } = ServerConstants;
const { REQUEST_TUTTI_BATCH_UPLOAD_ID, REQUEST_TUTTI_CLIENTS_ID } = ServiceConstants;

export async function tuttiClients(filter: ListFilterRequest) {
  const requestId = REQUEST_TUTTI_CLIENTS_ID;

  try {
    store.dispatch(start(requestId));

    let url = `${API_V1_TUTTI}/clients?page=${filter.page}`;
    if (filter.pageSize) url += `&pageSize=${filter.pageSize}`;
    if (filter.search) url += `&search=${filter.search}`;

    const response = await APIKit.get(url);

    const normalizedResponse = {
      ...response.data,
      page: response.data?.page ?? response.data?.number ?? 0,
    };

    store.dispatch(end(new ServiceModel(requestId, normalizedResponse)));
    return response.data;
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, tuttiClients, [filter], requestId);
    return undefined;
  }
}

export async function tuttiUploadBatch(
  file: File,
  note?: string,
): Promise<TuttiBatchUploadResponse | undefined> {
  const requestId = REQUEST_TUTTI_BATCH_UPLOAD_ID;

  try {
    store.dispatch(start(requestId));

    const formData = new FormData();
    formData.append("file", file);

    const response = await APIKit.post(`${API_V1_TUTTI}/batches`, formData, {
      params: note ? { note } : undefined,
      headers: { "Content-Type": "multipart/form-data" },
    });

    store.dispatch(end(new ServiceModel(requestId, response.data)));
    return response.data as TuttiBatchUploadResponse;
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, tuttiUploadBatch, [file, note], requestId);
    return undefined;
  }
}
